@if (!!model) {
  <div>
    <app-slip-component-header type="item-choices" [status]="model.status"></app-slip-component-header>
    <hr />
    <ion-row class="ion-justify-content-center">
      <ion-button class="ph-btn-white" (click)="buttonInfo.op.emit()">
        {{ buttonInfo.legend }}
      </ion-button>
    </ion-row>
    @if (hasPayment) {
      <app-student-slip-item-choices-payment
        [slipComponentInfo]="slipComponentInfo"
        [itemChoicesComponentInfo]="model"
        [paymentProgress]="progress"
        (paymentStatusChange)="paymentStatusChange.emit($event)"></app-student-slip-item-choices-payment>
    }
    <!-- <pre>{{model | json}}</pre> -->
  </div>
}
